(function () {
  'use strict';
  // Two resolutions: the ink is dithered at DW x DH (up to 2200 wide — the
  // "dots"), then downscaled ONCE with high-quality area filtering onto a
  // display canvas whose backing store is exactly the panel's device-pixel
  // size (W x H). The element is never CSS-resampled, which is what caused
  // the moiré grid earlier. The loupe reads the full-resolution ink.
  var W = 800, H = 600;              // display canvas, 1:1 device px
  var DW = 800, DH = 600;            // dither (ink dot) resolution
  var DPR = Math.min(3, window.devicePixelRatio || 1);
  var SW = 800, SH = 600;            // fixed canvas size for the sample scenes
  var PALETTE = [
    [242, 237, 227], // paper white
    [36, 33, 30],    // black
    [166, 58, 45],   // red
    [213, 175, 70],  // yellow
    [90, 110, 80],   // green
    [72, 93, 132]    // blue
  ];
  var PAPER = 'rgb(242,237,227)';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var result = document.getElementById('result');
  var overlay = document.getElementById('overlay');
  var rctx = result.getContext('2d');
  var octx = overlay.getContext('2d');
  var panel = document.getElementById('panel');
  var hint = document.getElementById('hint');
  var loupe = document.getElementById('loupe');
  var statusEl = document.getElementById('status');
  var replayBtn = document.getElementById('replay');

  var loupeUrl = null;    // dataURL of dithered result for the loupe
  var animId = 0;         // token to cancel a running animation
  var rendered = false;
  var lastSource = null;  // remembered so a resize can re-dither at the new size

  var ditherCanvas = document.createElement('canvas');
  var usedRealPipeline = false;

  // This closure's own copy of the funnel helper. The file became two IIFEs
  // and the original `track` (see the modal IIFE below) stopped being visible
  // here — so `track('ink_preview_photo')` threw a ReferenceError the moment a
  // photo was picked, and the upload flow silently did nothing (the same
  // no-symptom failure 0d15133 fixed for the wall's e-ink button). One
  // duplicated line beats sharing state across closures via a global.
  function track(n, p) { try { if (window.WallieCollect) window.WallieCollect(n, p || {}); } catch (_) {} }

  /* ---------- real product photos with a transparent display window ---------- */
  var FRAMES = window.WALLIE_PREVIEW.frames;
  var stageEl = document.getElementById('stageEl');
  var frameImg = document.getElementById('frameImg');
  // Size-aware frame art: on the 10″ page the stage opens with the 10″'s own
  // shot, not the 13″'s (keys with a -10 suffix; see wallie-ink-preview.liquid).
  function sizedKey(k) {
    return (window.WALLIE_PREVIEW.ten && FRAMES[k + '-10']) ? k + '-10' : k;
  }
  var currentFinish = sizedKey('round-walnut');
  var orientation = 'land';

  var currentF = null;
  function sizeStage() {
    if (!currentF) return;
    var w = stageEl.getBoundingClientRect().width;
    if (w > 10) stageEl.style.height = Math.round(w * currentF.h / currentF.w) + 'px';
  }
  function applyFinish() {
    var f = FRAMES[currentFinish][orientation];
    currentF = f;
    sizeStage();
    // the display window is cut out of the JPEG with an even-odd clip-path
    // (no alpha channel needed, so the photo keeps full JPEG quality)
    var b = f.box;
    var l = b[0] + '% ', t = b[1] + '%', r = (b[0] + b[2]) + '% ', bt = (b[1] + b[3]) + '%';
    var clip = 'polygon(evenodd, 0 0, 100% 0, 100% 100%, 0 100%, 0 0, ' +
      l + t + ', ' + l + bt + ', ' + r + bt + ', ' + r + t + ', ' + l + t + ')';
    frameImg.style.clipPath = clip;
    frameImg.style.webkitClipPath = clip;
    frameImg.src = f.src;
    panel.style.left = f.box[0] + '%';
    panel.style.top = f.box[1] + '%';
    panel.style.width = f.box[2] + '%';
    panel.style.height = f.box[3] + '%';
  }
  applyFinish();

  function sizePanel() {
    var rect = panel.getBoundingClientRect();
    if (rect.width < 10) return;
    var nw = Math.round(rect.width * DPR), nh = Math.round(rect.height * DPR);
    // assigning canvas.width WIPES the canvas — never touch it when unchanged
    // (a hidden->shown modal refits at identical size and must keep its render)
    if (nw === W && nh === H) return;
    W = nw; H = nh;
    // dither at the REAL panel grid — every render has exactly the frame's
    // 1600x1200 dots (13" Spectra, ~152 DPI), same on every device
    DW = orientation === 'port' ? 1200 : 1600;
    DH = orientation === 'port' ? 1600 : 1200;
    result.width = W; result.height = H;
    overlay.width = W; overlay.height = H;
    octx.fillStyle = PAPER;
    octx.fillRect(0, 0, W, H);
  }
  sizePanel();

  function refit() {
    var prevW = W, prevH = H;
    sizeStage();
    sizePanel();
    if (adjust) { drawAdjust(); return; }
    if (lastSource && lastSource.s && (Math.abs(W - prevW) > 8 || Math.abs(H - prevH) > 8)) {
      renderCache = {};
      // blank to paper while the new aspect renders — never show the old
      // render stretched into the new window
      result.classList.remove('on');
      overlay.classList.remove('gone');
      octx.globalCompositeOperation = 'source-over';
      octx.globalAlpha = 1;
      octx.fillStyle = PAPER;
      octx.fillRect(0, 0, W, H);
      runPipeline(true);
      return;
    }
    // same size but canvases may have been cleared (e.g. modal reopen):
    // repaint idempotently from the kept full-res ink
    if (rendered && ditherCanvas.width > 0) {
      rctx.imageSmoothingEnabled = true;
      rctx.imageSmoothingQuality = 'high';
      drawInkScaled(rctx, W, H);
      result.classList.add('on');
      overlay.classList.add('gone');
    }
  }
  var resizeT;
  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(refit, 250);
  });
  // the stage takes its height from the photo, so refit once it decodes
  // (and again on every finish/orientation swap)
  frameImg.addEventListener('load', refit);

  function setStatus(msg) {
    statusEl.innerHTML = msg ? '<span class="dot">●</span> ' + msg : '';
  }

  /* ---------- dithering ---------- */
  function nearest(r, g, b) {
    var best = 0, bd = Infinity;
    for (var i = 0; i < PALETTE.length; i++) {
      var p = PALETTE[i];
      var rm = (r + p[0]) * 0.5;
      var dr = r - p[0], dg = g - p[1], db = b - p[2];
      var d = (2 + rm / 256) * dr * dr + 4 * dg * dg + (2 + (255 - rm) / 256) * db * db;
      if (d < bd) { bd = d; best = i; }
    }
    return best;
  }

  // Draws `source` cover-cropped, pre-processes (contrast + saturation, like the
  // real pipeline compensates for a muted panel), then serpentine Floyd-Steinberg.
  function dither(source, sw, sh) {
    var work = document.createElement('canvas');
    work.width = W; work.height = H;
    var wctx = work.getContext('2d');
    var scale = Math.max(W / sw, H / sh);
    var dw = sw * scale, dh = sh * scale;
    wctx.drawImage(source, (W - dw) / 2, (H - dh) / 2, dw, dh);

    var img = wctx.getImageData(0, 0, W, H);
    var d = img.data;
    var buf = new Float32Array(W * H * 3);
    for (var i = 0, j = 0; i < d.length; i += 4, j += 3) {
      var r = d[i], g = d[i + 1], b = d[i + 2];
      var l = 0.299 * r + 0.587 * g + 0.114 * b;
      // saturation boost 1.28, gentle contrast around mid, plus a whisper of
      // noise so smooth gradients don't lock into repeating dither structure
      r = l + (r - l) * 1.28; g = l + (g - l) * 1.28; b = l + (b - l) * 1.28;
      buf[j]     = 128 + (r - 128) * 1.08 + (Math.random() - 0.5) * 3;
      buf[j + 1] = 128 + (g - 128) * 1.08 + (Math.random() - 0.5) * 3;
      buf[j + 2] = 128 + (b - 128) * 1.08 + (Math.random() - 0.5) * 3;
    }

    // Serpentine Jarvis-Judice-Ninke — the kernel the real pipeline uses.
    // Spreads error across 12 neighbours, which kills the columnar "worm"
    // structure Floyd-Steinberg develops in smooth gradient skies.
    var JJN = [
      [1, 0, 7], [2, 0, 5],
      [-2, 1, 3], [-1, 1, 5], [0, 1, 7], [1, 1, 5], [2, 1, 3],
      [-2, 2, 1], [-1, 2, 3], [0, 2, 5], [1, 2, 3], [2, 2, 1]
    ];
    var idx = new Uint8Array(W * H);
    for (var y = 0; y < H; y++) {
      var ltr = (y % 2 === 0);
      var step = ltr ? 1 : -1;
      for (var xi = 0; xi < W; xi++) {
        var x = ltr ? xi : (W - 1 - xi);
        var o = (y * W + x) * 3;
        var pr = Math.max(0, Math.min(255, buf[o]));
        var pg = Math.max(0, Math.min(255, buf[o + 1]));
        var pb = Math.max(0, Math.min(255, buf[o + 2]));
        var pi = nearest(pr, pg, pb);
        idx[y * W + x] = pi;
        var pal = PALETTE[pi];
        var er = pr - pal[0], eg = pg - pal[1], eb = pb - pal[2];
        for (var wi = 0; wi < 12; wi++) {
          var tap = JJN[wi];
          var nx = x + tap[0] * step, ny = y + tap[1];
          if (nx < 0 || nx >= W || ny >= H) continue;
          var n = (ny * W + nx) * 3, wgt = tap[2] / 48;
          buf[n] += er * wgt; buf[n + 1] += eg * wgt; buf[n + 2] += eb * wgt;
        }
      }
    }

    for (var k = 0; k < idx.length; k++) {
      var p2 = PALETTE[idx[k]], o2 = k * 4;
      d[o2] = p2[0]; d[o2 + 1] = p2[1]; d[o2 + 2] = p2[2]; d[o2 + 3] = 255;
    }
    img.data.set(d);
    return { image: img, idx: idx };
  }

  /* ---------- panel refresh animation ----------
     A compressed (~2s) version of how the Spectra panel actually redraws:
     whole-image passes — dark flush, paper flush, a full negative as the
     pigments migrate, a washed positive, a faint negative echo, then the
     image saturates into place. Every frame is the complete image at true
     dot resolution, and the final frame is pixel-identical to the result
     canvas, so the handoff is seamless. */
  function playFormation(then) {
    var token = ++animId;
    overlay.classList.remove('gone');
    result.classList.remove('on');
    var TOTAL = 2100;
    var t0 = performance.now();
    function negative(strength) {
      octx.globalCompositeOperation = 'difference';
      octx.globalAlpha = strength;
      octx.fillStyle = '#fff';
      octx.fillRect(0, 0, W, H);
      octx.globalCompositeOperation = 'source-over';
      octx.globalAlpha = 1;
    }
    function paperFill() {
      octx.globalAlpha = 1;
      octx.fillStyle = PAPER;
      octx.fillRect(0, 0, W, H);
    }
    function tick(now) {
      if (token !== animId) return;
      var t = now - t0;
      octx.globalCompositeOperation = 'source-over';
      octx.globalAlpha = 1;
      if (t < 160) {                       // dark flush
        octx.fillStyle = '#221f1c';
        octx.fillRect(0, 0, W, H);
      } else if (t < 340) {                // paper flush
        paperFill();
      } else if (t < 560) {               // full negative — pigments mid-flight
        octx.drawImage(result, 0, 0);
        negative(1);
      } else if (t < 660) {                // paper flush
        paperFill();
      } else if (t < 900) {                // washed positive
        paperFill();
        octx.globalAlpha = 0.45;
        octx.drawImage(result, 0, 0);
      } else if (t < 1080) {               // faint negative echo
        paperFill();
        octx.globalAlpha = 0.85;
        octx.drawImage(result, 0, 0);
        negative(0.35);
      } else if (t < TOTAL) {              // saturate into place
        var a = 0.5 + 0.5 * ((t - 1080) / (TOTAL - 1080));
        paperFill();
        octx.globalAlpha = Math.min(1, a);
        octx.drawImage(result, 0, 0);
      } else {
        octx.drawImage(result, 0, 0);
        reveal(then);
        return;
      }
      octx.globalAlpha = 1;
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function reveal(then) {
    result.classList.add('on');
    overlay.classList.add('gone');
    rendered = true;
    // `ms` is from the PICK, so it includes however long the shopper spent
    // placing the photo; `render_ms` is the wait itself, from their confirm.
    track('ink_preview_rendered', {
      ms: window.__wallieInkPicked ? Date.now() - window.__wallieInkPicked : null,
      render_ms: window.__wallieInkConfirmed ? Date.now() - window.__wallieInkConfirmed : null });
    // Save Your Wall listens for this. A DOM event rather than a direct call so
    // the ask stays entirely inside its own snippet and this file keeps its rule
    // of never depending on anything else being present.
    // `modal` lives in the other closure — look it up; a bare `modal` here was
    // a caught ReferenceError that silently killed the Save-Your-Wall listener.
    try {
      var modalEl = document.getElementById('tryModal');
      if (modalEl) modalEl.dispatchEvent(new CustomEvent('wallie:rendered'));
    } catch (_) {}
    pipelineBusy = false;
    replayBtn.hidden = false;
    expandBtn.hidden = false;
    addBtn.hidden = false;
    frameToggle.hidden = false;
    infoBtn.hidden = false;
    if (photoMode) setView('ink');
    if (!loupeSeen) loupeHint.hidden = false;
    if (!loupePeeked) { loupePeeked = true; setTimeout(peekLoupe, 500); }
    setStatus('');
    if (then) then();
  }

  /* ---------- the real pipeline (loaded as a plain script asset) ---------- */
  function runRealProcessor(rgba, w, h, opts) {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        try { resolve(window.wallieProcess(rgba, w, h, opts)); }
        catch (err) { reject(err); }
      }, 60);
    });
  }

  /* ---------- render entry ---------- */
  // Each mode changes exactly ONE thing vs the shipping pipeline (except v2,
  // which is the existing flag-gated prototype) so the warm cast can be
  // attributed to a single stage.
  // shopper-facing default: the shipping pipeline with saturation dialed to
  // 0.7 — the owner-picked anti-warm-cast setting from the tuning session
  // paletteMapping 0 = no hue snap: V1 snaps 5-55° hues toward Red (Yellow is
  // banned as a snap target there), which turned a gold wall mustard-brown
  // (2026-08-22 couple photo). Skin was unchanged with it off.
  //
  // 2026-10-04 (owner: "the new settings are good to publish"): the shopper
  // render is now the PHONE's default recipe for an untouched photo — measured
  // white balance, the cool default, tight dither, blue-noise seeding, the
  // teal pull, WITHOUT its white balance or cool default — at 0.9 saturation, owner 2026-10-04 (saturationScale 0.8182 x the
  // phone's 1.1). SITE_OPTS is the August call, kept for the gated Render row.
  var SITE_OPTS = '{"saturation":0.7,"paletteMapping":0}';
  // whiteBalance false (same day: "going too cold on the site"): with no person
  // verdict in a browser the measured white balance treats every photo as
  // scenery and cools a warm room hard; the cool default alone stays.
  // cool 0.5 (owner, same day, after seeing it at 0: "the warmth might be a
  // touch strong now"): half of the phone's cool default (-0.075 warmth) answers a warm cast on
  // the GLASS; a screen has none, so here it only read as cold. Measured on
  // three corpus photos: with it off the preview's warmth is back at August's.
  var OPTS = '{"app":"plain","saturationScale":0.8182,"whiteBalance":false,"cool":0.5}';
  var renderCache = {};  // opts -> rendered ink canvas, valid for lastSource

  function renderSource(source, sw, sh, label, skipAnim, needsCrop) {
    lastSource = { s: source, sw: sw, sh: sh, label: label, ox: 0.5, oy: 0.5, z: 1 };
    renderCache = {};
    loupePeeked = false;
    loupeHint.hidden = true;
    expandBtn.hidden = true;
    addBtn.hidden = true;
    replayBtn.hidden = true;
    frameToggle.hidden = true;
    photoMode = false;
    infoBtn.hidden = true;
    infoPop.hidden = true;
    if (needsCrop) { enterAdjust(); return; }
    runPipeline(skipAnim);
  }

  // The pipeline previews with the panel's optimistic legacy palette; remap
  // each ink to the community-measured Spectra 6 values (white is a ~52%-
  // reflectance blue-gray, red is dark brick) so the preview matches what
  // the physical panel actually shows. Same dither, honest inks.
  // Targets are a 50/50 blend of the optimistic legacy palette and the
  // community-measured Spectra 6 values: the measured hues (cool white,
  // brick-leaning red) with saturation/brightness recovered halfway.
  var PANEL_REMAP = [
    [[25, 30, 33], [28, 32, 36]],
    [[232, 232, 232], [209, 216, 217]],
    [[239, 222, 68], [216, 205, 49]],
    [[178, 19, 24], [138, 26, 27]],
    [[33, 87, 186], [34, 75, 164]],
    [[18, 95, 32], [36, 91, 45]]
  ];
  function remapToMeasuredPanel(c) {
    var ctx = c.getContext('2d');
    var img = ctx.getImageData(0, 0, c.width, c.height);
    var d = img.data;
    var map = {};
    for (var i = 0; i < PANEL_REMAP.length; i++) {
      var a = PANEL_REMAP[i][0];
      map[(a[0] << 16) | (a[1] << 8) | a[2]] = PANEL_REMAP[i][1];
    }
    for (var p = 0; p < d.length; p += 4) {
      var m = map[(d[p] << 16) | (d[p + 1] << 8) | d[p + 2]];
      if (m) { d[p] = m[0]; d[p + 1] = m[1]; d[p + 2] = m[2]; }
    }
    ctx.putImageData(img, 0, 0);
  }

  /* ---------- spot-color styles (experiment, 2026-09-05) ----------
     Instead of asking six inks to reproduce a photograph, treat them as the
     spot colors of a print: pick two or three, map tone and warmth onto them,
     and dither only among those. The eye stops reading "failed photo" and
     starts reading "print". Same 1600x1200 grid, same measured inks. */
  var STYLE = 'photo';
  var STYLE_NAMES = { mono: 'ink & paper', blue: 'blue duotone', red: 'red duotone', gold: 'gold tritone', riso: 'riso', poster: 'poster' };
  var INK = {                       // measured Spectra 6 (see PANEL_REMAP targets)
    paper: [209, 216, 217], black: [28, 32, 36], yellow: [216, 205, 49],
    red: [138, 26, 27], blue: [34, 75, 164], green: [36, 91, 45]
  };
  var STYLES = {
    mono:   { inks: ['paper', 'black'] },
    blue:   { inks: ['paper', 'blue', 'black'], ramp: ['paper', 'blue', 'black'] },
    red:    { inks: ['paper', 'red', 'black'],  ramp: ['paper', 'red', 'black'] },
    gold:   { inks: ['paper', 'yellow', 'red', 'black'], ramp: ['paper', 'yellow', 'red', 'black'] },
    riso:   { inks: ['paper', 'red', 'blue', 'black'], split: true },
    poster: { inks: ['paper', 'black', 'yellow', 'red', 'blue', 'green'], flat: true }
  };
  function lerp3(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t]; }
  // t: 1 = paper, 0 = darkest. Stops sit at explicit tone positions (not
  // evenly spaced): a printed duotone keeps highlights on the paper and lets
  // the colour ink carry the mid-shadows, with black only in the deepest tones.
  var RAMP_POS = { 2: [1, 0], 3: [1, 0.42, 0], 4: [1, 0.62, 0.32, 0] };
  function rampColor(stops, t) {
    var pos = RAMP_POS[stops.length];
    for (var i = 0; i < stops.length - 1; i++) {
      if (t <= pos[i] && t >= pos[i + 1]) {
        var u = (pos[i] - t) / (pos[i] - pos[i + 1]);
        return lerp3(INK[stops[i]], INK[stops[i + 1]], u);
      }
    }
    return INK[stops[stops.length - 1]];
  }
  function renderStyled(rgba, w, h, styleKey) {
    var st = STYLES[styleKey];
    var n = w * h;
    var lum = new Float32Array(n), warm = new Float32Array(n);
    var hist = new Uint32Array(256);
    for (var i = 0, p = 0; i < n; i++, p += 4) {
      var r = rgba[p], g = rgba[p + 1], b = rgba[p + 2];
      var y = 0.299 * r + 0.587 * g + 0.114 * b;
      lum[i] = y; hist[y | 0]++;
      warm[i] = (r - b) / 255;          // + warm, - cool
    }
    // auto-levels: stretch the 0.5%..99.5% span onto paper..ink like a print
    var lo = 0, hi = 255, acc = 0;
    for (var k = 0; k < 256; k++) { acc += hist[k]; if (acc > n * 0.005) { lo = k; break; } }
    acc = 0;
    for (k = 255; k >= 0; k--) { acc += hist[k]; if (acc > n * 0.005) { hi = k; break; } }
    if (hi - lo < 32) { lo = 0; hi = 255; }
    var target = new Float32Array(n * 3);
    for (i = 0; i < n; i++) {
      var t = (lum[i] - lo) / (hi - lo);
      t = t < 0 ? 0 : t > 1 ? 1 : t;
      t = t * t * (3 - 2 * t);          // gentle S-curve: prints have punch
      var c;
      if (st.split) {
        // riso: warmth picks the ink, tone picks its density; deep shadows go black
        var wv = warm[i];
        var ink = wv >= 0 ? INK.red : INK.blue;
        var mix = Math.min(1, Math.abs(wv) * 2.2 + 0.25);   // how much the hue ink vs. neutral
        var tint = lerp3(lerp3(INK.paper, INK.black, 0.5), ink, mix);
        c = t > 0.42 ? lerp3(tint, INK.paper, (t - 0.42) / 0.58) : lerp3(INK.black, tint, t / 0.42);
      } else if (st.ramp) {
        c = rampColor(st.ramp, t);
      } else if (st.flat) {
        // poster: hard tone steps + full hue, no dithering below
        var q = Math.round(t * 3) / 3;
        var s = 1.6;
        var m = lum[i];
        c = [m + (rgba[i * 4] - m) * s, m + (rgba[i * 4 + 1] - m) * s, m + (rgba[i * 4 + 2] - m) * s];
        var f = 0.35 + q * 0.65;
        c = [c[0] * f + 20 * (1 - f), c[1] * f + 20 * (1 - f), c[2] * f + 20 * (1 - f)];
      } else {
        c = lerp3(INK.black, INK.paper, t);
      }
      target[i * 3] = c[0]; target[i * 3 + 1] = c[1]; target[i * 3 + 2] = c[2];
    }
    var pal = st.inks.map(function (k) { return INK[k]; });
    var out = new Uint8ClampedArray(n * 4);
    var err = new Float32Array((w + 2) * 3 * 2);   // two rows, 1px margin each side
    function nearestPal(r, g, b) {
      var best = 0, bd = Infinity;
      for (var j = 0; j < pal.length; j++) {
        var dr = r - pal[j][0], dg = g - pal[j][1], db = b - pal[j][2];
        var d = dr * dr * 0.9 + dg * dg * 1.4 + db * db * 0.7;
        if (d < bd) { bd = d; best = j; }
      }
      return pal[best];
    }
    for (var yy = 0; yy < h; yy++) {
      var cur = (yy & 1) * (w + 2) * 3, nxt = ((yy + 1) & 1) * (w + 2) * 3;
      for (var z = 0; z < (w + 2) * 3; z++) err[nxt + z] = 0;
      var ltr = (yy & 1) === 0;           // serpentine scan hides worm artifacts
      for (var xi = 0; xi < w; xi++) {
        var x = ltr ? xi : w - 1 - xi;
        var idx = yy * w + x;
        var ei = cur + (x + 1) * 3;
        var tr = target[idx * 3], tg = target[idx * 3 + 1], tb = target[idx * 3 + 2];
        var q0;
        if (st.flat) { q0 = nearestPal(tr, tg, tb); }
        else {
          tr += err[ei]; tg += err[ei + 1]; tb += err[ei + 2];
          q0 = nearestPal(tr, tg, tb);
          var er = (tr - q0[0]) * 0.85, eg = (tg - q0[1]) * 0.85, eb = (tb - q0[2]) * 0.85;
          var dx = ltr ? 3 : -3;
          err[ei + dx] += er * 7 / 16; err[ei + dx + 1] += eg * 7 / 16; err[ei + dx + 2] += eb * 7 / 16;
          var ni = nxt + (x + 1) * 3;
          err[ni - dx] += er * 3 / 16; err[ni - dx + 1] += eg * 3 / 16; err[ni - dx + 2] += eb * 3 / 16;
          err[ni] += er * 5 / 16; err[ni + 1] += eg * 5 / 16; err[ni + 2] += eb * 5 / 16;
          err[ni + dx] += er * 1 / 16; err[ni + dx + 1] += eg * 1 / 16; err[ni + dx + 2] += eb * 1 / 16;
        }
        var o = idx * 4;
        out[o] = q0[0]; out[o + 1] = q0[1]; out[o + 2] = q0[2]; out[o + 3] = 255;
      }
    }
    var c2 = document.createElement('canvas');
    c2.width = w; c2.height = h;
    c2.getContext('2d').putImageData(new ImageData(out, w, h), 0, 0);
    return c2;
  }
  /* ---------- dot-gain experiment (2026-09-05, gated with the Style row) ----------
     PRINT CURVE: a transfer curve on source luminance, fitted offline by running
     a 24-step grey wedge through THIS shipping bundle and a panel model
     (physical spread + Yule-Nielsen scatter, n = 1.4 / 1.6 / 1.8), so that the
     gained tone curve matches the ungained one. Highlights compress by design.
     PANEL: a view-only simulation of the same model on the finished ink, so the
     compensated render is judged through the panel instead of just looking
     brighter. The loupe, lightbox and gallery composites stay on the raw dots. */
  var CURVE_LUT = {
    mild: [0, 1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 13, 15, 16, 18, 19, 21, 22, 24, 25, 26, 28, 30, 31, 33, 35, 37, 38, 40, 42, 44, 45, 47, 49, 50, 51, 52, 53, 54, 56, 57, 58, 59, 60, 61, 63, 64, 65, 66, 68, 69, 70, 71, 72, 74, 75, 77, 78, 79, 81, 82, 84, 85, 87, 88, 90, 91, 93, 95, 96, 98, 100, 101, 103, 104, 106, 108, 109, 110, 111, 112, 113, 113, 114, 115, 116, 117, 118, 118, 119, 120, 121, 122, 123, 124, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 145, 146, 147, 148, 149, 150, 151, 153, 154, 155, 156, 157, 158, 160, 161, 162, 163, 164, 165, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 182, 183, 184, 185, 186, 187, 188, 189, 189, 190, 190, 191, 191, 192, 193, 193, 194, 194, 195, 196, 197, 197, 198, 199, 200, 201, 201, 202, 203, 204, 204, 205, 206, 207, 208, 209, 209, 210, 211, 212, 212, 213, 214, 214, 215, 216, 216, 217, 218, 218, 219, 219, 220, 220, 221, 222, 222, 223, 223, 224, 224, 225, 225, 226, 226, 227, 227, 228, 228, 229, 230, 230, 231, 231, 232, 233, 234, 234, 235, 236, 236, 237, 238, 239, 239, 240, 240, 240, 241, 241, 242, 242, 243, 243, 244, 244, 244, 244, 244, 244, 244, 244, 244, 244, 244, 244],
    mid: [0, 1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 13, 15, 16, 18, 19, 21, 22, 23, 25, 26, 28, 30, 31, 33, 35, 37, 39, 40, 42, 44, 46, 48, 49, 50, 51, 53, 54, 55, 56, 58, 59, 60, 61, 63, 64, 65, 66, 68, 69, 70, 71, 73, 74, 75, 77, 79, 80, 82, 84, 85, 87, 89, 91, 92, 94, 96, 97, 99, 101, 103, 104, 106, 108, 109, 111, 113, 114, 115, 116, 117, 118, 119, 120, 121, 121, 122, 123, 124, 125, 126, 127, 127, 128, 129, 130, 131, 132, 133, 133, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 151, 152, 153, 154, 155, 156, 158, 159, 161, 162, 164, 165, 166, 168, 169, 171, 172, 173, 174, 175, 176, 177, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 195, 195, 196, 196, 197, 198, 198, 199, 199, 200, 200, 201, 202, 203, 203, 204, 205, 206, 206, 207, 208, 209, 210, 210, 211, 211, 212, 212, 213, 213, 214, 214, 215, 216, 216, 217, 217, 218, 218, 219, 219, 220, 221, 221, 222, 222, 223, 223, 224, 224, 224, 225, 225, 226, 226, 227, 227, 227, 228, 228, 229, 229, 230, 230, 231, 231, 231, 232, 233, 233, 234, 235, 235, 236, 237, 237, 238, 239, 240, 241, 242, 244, 245, 247, 248, 249, 251, 252, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
    strong: [0, 1, 2, 4, 5, 6, 7, 8, 9, 11, 12, 13, 15, 17, 19, 22, 24, 26, 28, 30, 32, 34, 36, 39, 41, 43, 45, 47, 50, 52, 54, 56, 58, 60, 62, 63, 65, 66, 67, 68, 70, 71, 72, 74, 75, 77, 79, 81, 83, 84, 86, 88, 90, 92, 94, 96, 97, 99, 100, 102, 103, 105, 106, 108, 109, 110, 112, 113, 115, 117, 118, 120, 121, 123, 125, 126, 128, 129, 131, 132, 132, 133, 134, 135, 136, 136, 137, 138, 139, 140, 141, 142, 142, 143, 144, 145, 146, 147, 147, 148, 149, 150, 152, 153, 154, 155, 156, 158, 159, 160, 161, 162, 163, 164, 166, 167, 168, 169, 170, 171, 172, 173, 174, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 192, 193, 194, 195, 196, 197, 198, 199, 199, 200, 201, 202, 203, 204, 205, 206, 206, 207, 207, 208, 208, 209, 209, 210, 210, 211, 211, 212, 212, 213, 213, 213, 214, 214, 215, 215, 215, 216, 216, 217, 217, 218, 218, 218, 219, 219, 220, 220, 221, 221, 221, 222, 222, 223, 223, 223, 224, 224, 225, 225, 226, 226, 226, 227, 227, 227, 228, 228, 228, 229, 229, 229, 230, 230, 231, 231, 231, 232, 232, 233, 233, 233, 234, 234, 235, 236, 236, 237, 237, 238, 239, 239, 240, 241, 242, 243, 244, 246, 247, 248, 250, 251, 252, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]
  };
  var GAIN_PARAMS = { mild: [1.4, 0.7, 0.10], mid: [1.6, 0.5, 0.15], strong: [1.8, 1.0, 0.20] };  // n, sigma, spread
  var CURVE = 'off', GAIN = 'off';
  var simCache = { src: null, level: null, canvas: null };
  function applyCurve(rgba, level) {
    var lut = CURVE_LUT[level]; if (!lut) return;
    for (var p = 0; p < rgba.length; p += 4) {
      var r = rgba[p], g = rgba[p + 1], b = rgba[p + 2];
      var y = 0.299 * r + 0.587 * g + 0.114 * b;
      if (y < 1) continue;
      var k = lut[Math.round(y)] / y;
      rgba[p] = Math.min(255, r * k); rgba[p + 1] = Math.min(255, g * k); rgba[p + 2] = Math.min(255, b * k);
    }
  }
  var LIN = new Float32Array(256), SRGB8 = new Uint8ClampedArray(4096);
  (function () {
    for (var i = 0; i < 256; i++) { var v = i / 255; LIN[i] = v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
    for (var j = 0; j < 4096; j++) { var l = j / 4095; SRGB8[j] = Math.round(255 * (l <= 0.0031308 ? l * 12.92 : 1.055 * Math.pow(l, 1 / 2.4) - 0.055)); }
  })();
  function blurSep(a, w, h, sigma) {
    var r = Math.ceil(3 * sigma), k = new Float32Array(2 * r + 1), sum = 0, i;
    for (i = -r; i <= r; i++) { k[i + r] = Math.exp(-i * i / (2 * sigma * sigma)); sum += k[i + r]; }
    for (i = 0; i < k.length; i++) k[i] /= sum;
    var t = new Float32Array(w * h), o = new Float32Array(w * h), x, y, acc, d, xx, yy;
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
      acc = 0; for (d = -r; d <= r; d++) { xx = x + d; xx = xx < 0 ? 0 : xx >= w ? w - 1 : xx; acc += a[y * w + xx] * k[d + r]; }
      t[y * w + x] = acc;
    }
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
      acc = 0; for (d = -r; d <= r; d++) { yy = y + d; yy = yy < 0 ? 0 : yy >= h ? h - 1 : yy; acc += t[yy * w + x] * k[d + r]; }
      o[y * w + x] = acc;
    }
    return o;
  }
  function panelSim(src, level) {
    var P = GAIN_PARAMS[level]; if (!P) return src;
    if (simCache.src === src && simCache.level === level) return simCache.canvas;
    var n = P[0], sigma = P[1], spread = P[2];
    var w = src.width, h = src.height, N = w * h;
    var d = src.getContext('2d').getImageData(0, 0, w, h).data;
    var out = new Uint8ClampedArray(N * 4);
    for (var c = 0; c < 3; c++) {
      var R = new Float32Array(N), i, x, y;
      for (i = 0; i < N; i++) R[i] = LIN[d[i * 4 + c]];
      if (spread > 0) {
        var M = new Float32Array(N);
        for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
          var m = 1, y0 = y > 0 ? y - 1 : 0, y1 = y < h - 1 ? y + 1 : h - 1, x0 = x > 0 ? x - 1 : 0, x1 = x < w - 1 ? x + 1 : w - 1;
          for (var yy = y0; yy <= y1; yy++) for (var xx = x0; xx <= x1; xx++) { var v = R[yy * w + xx]; if (v < m) m = v; }
          M[y * w + x] = m;
        }
        for (i = 0; i < N; i++) R[i] = (1 - spread) * R[i] + spread * M[i];
      }
      var inv = 1 / n;
      for (i = 0; i < N; i++) R[i] = Math.pow(R[i], inv);
      R = blurSep(R, w, h, sigma);
      for (i = 0; i < N; i++) out[i * 4 + c] = SRGB8[Math.round(Math.pow(R[i], n) * 4095)];
    }
    for (var q = 3; q < N * 4; q += 4) out[q] = 255;
    var cnv = document.createElement('canvas'); cnv.width = w; cnv.height = h;
    cnv.getContext('2d').putImageData(new ImageData(out, w, h), 0, 0);
    simCache = { src: src, level: level, canvas: cnv };
    return cnv;
  }
  function displaySource() { return GAIN === 'off' ? ditherCanvas : panelSim(ditherCanvas, GAIN); }
  function setGainLevel(v) {
    if (!(v === 'off' || GAIN_PARAMS[v])) return;
    GAIN = v;
    Array.prototype.forEach.call(document.querySelectorAll('[data-gain]'), function (b) { b.classList.toggle('on', b.getAttribute('data-gain') === v); });
    if (rendered && !pipelineBusy && !adjust) { setStatus(v === 'off' ? '' : 'Simulating the panel…'); setTimeout(function () { finishRender(true); }, 30); }
  }
  function setCurveLevel(v) {
    if (!(v === 'off' || CURVE_LUT[v])) return;
    CURVE = v;
    Array.prototype.forEach.call(document.querySelectorAll('[data-curve]'), function (b) { b.classList.toggle('on', b.getAttribute('data-curve') === v); });
    setStyle(STYLE);   // re-render through the same restored-source path
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-gain]'), function (btn) {
    btn.addEventListener('click', function () { setGainLevel(btn.getAttribute('data-gain')); });
  });
  Array.prototype.forEach.call(document.querySelectorAll('[data-curve]'), function (btn) {
    btn.addEventListener('click', function () { setCurveLevel(btn.getAttribute('data-curve')); });
  });
  // RENDER (gated with the Style row, 2026-10-04): which recipe the Photo
  // style asks the bundle for. "site" is the shopper-facing call above;
  // "plain" and "boost" are the phone's own default render for an untouched
  // photo (scripts/eink_web/bin/main.dart). Boost here is the recipe for a
  // photo without people: a browser has no colour model for skin and hair.
  // saturationScale: the theme runs the phone's recipes at 0.7/1.1 of their
  // saturation (plain lands on 0.9; the August site call was 0.7) — no skin handling here to tame it.
  var LOOKS = { site: SITE_OPTS, plain: OPTS, boost: '{"app":"boost","saturationScale":0.8182,"whiteBalance":false,"cool":0.5}' };
  function setLook(key, quiet) {
    if (!LOOKS[key]) return;
    OPTS = LOOKS[key];
    Array.prototype.forEach.call(document.querySelectorAll('[data-look]'), function (b) { b.classList.toggle('on', b.getAttribute('data-look') === key); });
    if (!quiet) setStyle(STYLE);
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-look]'), function (btn) {
    btn.addEventListener('click', function () { setLook(btn.getAttribute('data-look')); });
  });

  function setStyle(key) {
    if (!STYLES[key] && key !== 'photo') return;
    STYLE = key;
    Array.prototype.forEach.call(document.querySelectorAll('[data-style]'), function (b) {
      b.classList.toggle('on', b.getAttribute('data-style') === key);
    });
    if (!lastSource || adjust) return;
    // A restored session (reload) keeps only the framed original — promote it
    // to a re-renderable source: it is already DWxDH, so cover-fit is identity.
    if (!lastSource.s && lastSource.orig) {
      lastSource = { s: lastSource.orig, sw: lastSource.orig.width, sh: lastSource.orig.height,
        label: 'your photo', ox: 0.5, oy: 0.5, z: 1, orig: lastSource.orig };
      renderCache = {};
    }
    if (!lastSource.s) return;
    pipelineBusy = false;   // a style switch always wins over a stalled paint
    runPipeline(false);
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-style]'), function (btn) {
    btn.addEventListener('click', function () { setStyle(btn.getAttribute('data-style')); });
  });
  // Experiment gate: the Style row is hidden unless the URL carries #inkstyles
  // (remembered for the session so the modal keeps it across variant morphs).
  try {
    if (location.hash.indexOf('inkstyles') !== -1) sessionStorage.setItem('wallieInkStyles', '1');
    if (sessionStorage.getItem('wallieInkStyles') === '1') {
      Array.prototype.forEach.call(document.querySelectorAll('.finishes.styles'), function (row) { row.classList.add('show'); });
    }
  } catch (_) {}

  function runPipeline(skipAnim) {
    var opts = OPTS + '|' + STYLE + '|' + CURVE;
    if (H < 10) sizePanel();
    if (H < 10) { setStatus('Sizing the frame — one sec, then tap again.'); return; }
    hint.classList.add('gone');
    var cached = renderCache[opts];
    if (cached) {
      ditherCanvas = cached;
      usedRealPipeline = cached.realPipeline;
      finishRender(true);
      return;
    }
    pipelineBusy = true;
    var label = lastSource.label || 'your photo';
    var t0 = performance.now();
    setStatus('Painting in e-ink: “' + label + '”…');

    var work = document.createElement('canvas');
    work.width = DW; work.height = DH;
    var wctx = work.getContext('2d');
    var scale = Math.max(DW / lastSource.sw, DH / lastSource.sh) * (lastSource.z || 1);
    var dw = lastSource.sw * scale, dh = lastSource.sh * scale;
    wctx.drawImage(lastSource.s, (DW - dw) * lastSource.ox, (DH - dh) * lastSource.oy, dw, dh);
    lastSource.orig = work;   // the framed original, for the Photo/Ink toggle
    var rgba = new Uint8Array(wctx.getImageData(0, 0, DW, DH).data.buffer.slice(0));
    if (CURVE !== 'off') applyCurve(rgba, CURVE);

    if (STYLE !== 'photo') {
      setStatus('Printing in ' + (STYLE_NAMES[STYLE] || STYLE) + ': “' + label + '”…');
      setTimeout(function () {
        var c = renderStyled(rgba, DW, DH, STYLE);
        c.realPipeline = true;       // real panel grid + measured inks
        renderCache[opts] = c;
        ditherCanvas = c;
        usedRealPipeline = true;
        finishRender(skipAnim);
      }, 40);
      return;
    }

    var ticker = setInterval(function () {
      var s = Math.round((performance.now() - t0) / 1000);
      if (s >= 1) setStatus('Painting in e-ink: “' + label + '”… ' + s + 's');
    }, 500);

    function attempt(triesLeft) {
      return runRealProcessor(rgba, DW, DH, OPTS).then(function (png) {
        return createImageBitmap(new Blob([png], { type: 'image/png' }));
      }).then(function (bmp) {
        clearInterval(ticker);
        var c = document.createElement('canvas');
        c.width = DW; c.height = DH;
        c.getContext('2d').drawImage(bmp, 0, 0);
        remapToMeasuredPanel(c);
        c.realPipeline = true;
        renderCache[opts] = c;
        ditherCanvas = c;
        usedRealPipeline = true;
        finishRender(skipAnim);
      }).catch(function (err) {
        if (triesLeft > 0) return attempt(triesLeft - 1);
        clearInterval(ticker);
        // never substitute a display-res approximation: it would poison the
        // render cache, the gallery composites, and the session ink cache
        pipelineBusy = false;
        if (rendered) {
          setStatus('Couldn’t repaint just now — showing your last preview.');
          finishRender(true);
        } else {
          setStatus('That didn’t quite take — tap the frame to try again.');
        }
      });
    }
    attempt(1);
  }

  function drawInkScaled(ctx, w, h) {
    var s = displaySource();
    while (s.width >= w * 1.15) {
      var t = document.createElement('canvas');
      t.width = Math.round(s.width / 2); t.height = Math.round(s.height / 2);
      var tc = t.getContext('2d');
      tc.imageSmoothingEnabled = true; tc.imageSmoothingQuality = 'high';
      tc.drawImage(s, 0, 0, t.width, t.height);
      s = t;
    }
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(s, 0, 0, w, h);
  }
  function finishRender(skipAnim) {
    // one controlled area-filtered downscale onto exact device pixels
    rctx.imageSmoothingEnabled = true;
    rctx.imageSmoothingQuality = 'high';
    rctx.clearRect(0, 0, W, H);
    drawInkScaled(rctx, W, H);
    loupeUrl = ditherCanvas.toDataURL();
    loupe.style.backgroundImage = 'url(' + loupeUrl + ')';
    if (reduceMotion || skipAnim) {
      ++animId;
      octx.fillStyle = PAPER; octx.fillRect(0, 0, W, H);
      reveal();
    } else {
      setStatus('Refreshing the panel…');
      playFormation();
    }
  }

  /* ---------- inputs ---------- */
  var fileInput = document.getElementById('file');
  var addBtn = document.getElementById('addBtn');
  var pipelineBusy = false;
  addBtn.addEventListener('click', function () { fileInput.click(); });
  panel.addEventListener('click', function () {
    if (!rendered && !adjust && !pipelineBusy) fileInput.click();
  });
  // A PHONE PHOTO IS FAR BIGGER THAN THIS PREVIEW NEEDS (2026-10-03: a 13.7 MB
  // and a 6 MB photo were picked and never produced a preview; the shopper
  // with the 13.7 MB one had six frames in the cart). The file used to be
  // decoded at FULL size — a 48-megapixel photo is ~190 MB of pixels, past
  // what a phone's canvas will hold — and handed whole to the crop step. It is
  // now brought down to MAX_SOURCE_EDGE on its long side as it is decoded.
  // The panel is 1600 px wide; 2400 leaves room to zoom in the crop step.
  var MAX_SOURCE_EDGE = 2400;
  function capDims(w, h, cap) {
    var long = Math.max(w, h);
    if (!(long > cap) || !(w > 0) || !(h > 0)) return { w: w, h: h, capped: false };
    var k = cap / long;
    return { w: Math.max(1, Math.round(w * k)), h: Math.max(1, Math.round(h * k)), capped: true };
  }
  function photoFailed(f, stage) {
    track('ink_preview_photo_failed', { stage: stage, type: f.type || null, bytes: f.size || null });
    setStatus('That photo format didn\u2019t load \u2014 JPG or PNG work best here.');
  }
  function photoLoaded(f, source, sw, sh, d, t0) {
    track('ink_preview_photo_loaded', { w: d.w, h: d.h, src_w: sw, src_h: sh, capped: d.capped,
      ms: Date.now() - t0, bytes: f.size || null });
    renderSource(source, d.w, d.h, f.name, false, true);
  }
  document.getElementById('file').addEventListener('change', function (e) {
    var f = e.target.files && e.target.files[0];
    if (!f) return;
    track('ink_preview_photo', { type: f.type || null, bytes: f.size || null });
    var pickedTs = Date.now();
    window.__wallieInkPicked = pickedTs;
    window.__wallieInkConfirmed = 0;
    setStatus('Opening your photo\u2026');
    loadCapped(f, pickedTs);
    e.target.value = '';
  });
  // The <img> reads the file's size from its header and lets the browser
  // decode at whatever size it can afford; the copy the preview keeps is
  // made already small. Upright either way: an <img> shows a photo the way
  // up it was taken.
  function loadCapped(f, t0) {
    var url = URL.createObjectURL(f);
    var img = new Image();
    img.onload = function () {
      var sw = img.naturalWidth, sh = img.naturalHeight;
      var d = capDims(sw, sh, MAX_SOURCE_EDGE);
      var done = function (source) { URL.revokeObjectURL(url); photoLoaded(f, source, sw, sh, d, t0); };
      var viaCanvas = function () {
        try {
          var c = document.createElement('canvas');
          c.width = d.w; c.height = d.h;
          var x = c.getContext('2d');
          x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
          x.drawImage(img, 0, 0, d.w, d.h);
          done(c);
        } catch (_) { URL.revokeObjectURL(url); photoFailed(f, 'canvas'); }
      };
      if (!d.capped) { done(img); return; }
      if (window.createImageBitmap) {
        createImageBitmap(img, { resizeWidth: d.w, resizeHeight: d.h, resizeQuality: 'high' })
          .then(function (bmp) {
            // an engine that ignores the resize options hands back the full size
            if (bmp.width > d.w * 1.5) { try { bmp.close(); } catch (_) {} viaCanvas(); } else done(bmp);
          })
          .catch(viaCanvas);
      } else viaCanvas();
    };
    img.onerror = function () {
      URL.revokeObjectURL(url);
      // A format an <img> will not open may still decode directly.
      if (window.createImageBitmap) {
        createImageBitmap(f, { imageOrientation: 'from-image' })
          .then(function (bmp) {
            var d = capDims(bmp.width, bmp.height, MAX_SOURCE_EDGE);
            if (!d.capped) { photoLoaded(f, bmp, bmp.width, bmp.height, d, t0); return; }
            var c = document.createElement('canvas');
            c.width = d.w; c.height = d.h;
            c.getContext('2d').drawImage(bmp, 0, 0, d.w, d.h);
            photoLoaded(f, c, bmp.width, bmp.height, d, t0);
          })
          .catch(function () { photoFailed(f, 'decode'); });
      } else photoFailed(f, 'decode');
    };
    img.src = url;
  }

  replayBtn.addEventListener('click', function () {
    if (rendered) playFormation();
  });

  /* ---------- loupe ---------- */
  var LOUPE_MAG = 5.7;   // magnification vs the displayed image
  var loupeHint = document.getElementById('loupeHint');
  var loupeSeen = false, loupePeeked = false;

  function placeLoupe(x, y, touch) {
    // magnify relative to the DISPLAYED image (~2.6x) so what's under the
    // loupe stays recognizable, with the ink dots as visible grain
    var rect = panel.getBoundingClientRect();
    var srect = stageEl.getBoundingClientRect();
    loupe.style.display = 'block';
    var R = (loupe.offsetWidth / 2) || 80;
    var cy = touch ? Math.max(R * 0.6, y - 95) : y;   // lift above the finger
    loupe.style.left = (rect.left - srect.left + x - R) + 'px';
    loupe.style.top = (rect.top - srect.top + cy - R) + 'px';
    loupe.style.backgroundSize = (rect.width * LOUPE_MAG) + 'px ' + (rect.height * LOUPE_MAG) + 'px';
    loupe.style.backgroundPosition = (-(x * LOUPE_MAG) + R) + 'px ' + (-(y * LOUPE_MAG) + R) + 'px';
  }

  function moveLoupe(e) {
    if (!rendered || adjust || photoMode) return;
    var rect = panel.getBoundingClientRect();
    var x = e.clientX - rect.left, y = e.clientY - rect.top;
    if (x < 0 || y < 0 || x > rect.width || y > rect.height) { loupe.style.display = 'none'; return; }
    if (!loupeSeen) { loupeSeen = true; loupeHint.hidden = true; }
    placeLoupe(x, y, e.pointerType === 'touch');
  }

  /* ---------- about-this-preview popover ---------- */
  var infoBtn = document.getElementById('infoBtn');
  var infoPop = document.getElementById('infoPop');
  infoBtn.addEventListener('click', function () { infoPop.hidden = !infoPop.hidden; });
  infoPop.addEventListener('click', function () { infoPop.hidden = true; });

  /* ---------- before/after: Photo vs Ink on the frame ---------- */
  var frameToggle = document.getElementById('frameToggle');
  var photoMode = false;
  function setView(v) {
    photoMode = (v === 'photo');
    Array.prototype.forEach.call(frameToggle.querySelectorAll('.ft-seg'), function (b) {
      b.classList.toggle('on', b.getAttribute('data-view') === v);
    });
    if (photoMode && lastSource && lastSource.orig) {
      ++animId;
      octx.globalCompositeOperation = 'source-over';
      octx.globalAlpha = 1;
      octx.drawImage(lastSource.orig, 0, 0, W, H);
      overlay.classList.remove('gone');
      loupe.style.display = 'none';
    } else {
      overlay.classList.add('gone');
    }
  }
  Array.prototype.forEach.call(document.querySelectorAll('.ft-seg'), function (btn) {
    btn.addEventListener('click', function () { setView(btn.getAttribute('data-view')); });
  });

  /* ---------- full-screen view of the ink (no frame in the way) ---------- */
  var expandBtn = document.getElementById('expandBtn');
  var lightbox = document.getElementById('lightbox');
  var lightboxImg = document.getElementById('lightboxImg');
  expandBtn.addEventListener('click', function () {
    if (!rendered || !loupeUrl) return;
    lightboxImg.src = loupeUrl;
    lightbox.hidden = false;
  });
  function closeLightbox() { lightbox.hidden = true; }
  document.getElementById('lightboxClose').addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });

  // one-time self-demo: the loupe peeks at the centre of a fresh render so
  // the press-and-hold gesture explains itself
  function peekLoupe() {
    if (reduceMotion || !rendered || adjust) return;
    var rect = panel.getBoundingClientRect();
    placeLoupe(rect.width * 0.5, rect.height * 0.45, false);
    setTimeout(function () { if (!adjust) loupe.style.display = 'none'; }, 1400);
  }
  panel.addEventListener('pointermove', moveLoupe);
  panel.addEventListener('pointerdown', moveLoupe);
  panel.addEventListener('pointerleave', function () { loupe.style.display = 'none'; });
  panel.addEventListener('pointerup', function () { loupe.style.display = 'none'; });


  /* ---------- finish + orientation pickers (mirror the PDP selectors) ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('.fin'), function (btn) {
    btn.addEventListener('click', function () {
      currentFinish = sizedKey(btn.getAttribute('data-finish'));
      document.getElementById('finishName').textContent = btn.getAttribute('data-name');
      Array.prototype.forEach.call(document.querySelectorAll('.fin'), function (b) {
        b.classList.toggle('sel', b === btn);
      });
      applyFinish();
      refit();
    });
  });
  Array.prototype.forEach.call(document.querySelectorAll('[data-orient]'), function (btn) {
    btn.addEventListener('click', function () {
      var o = btn.getAttribute('data-orient');
      if (o === orientation) return;
      orientation = o;
      Array.prototype.forEach.call(document.querySelectorAll('[data-orient]'), function (b) {
        b.classList.toggle('on', b === btn);
      });
      applyFinish();
      refit();
    });
  });

  /* ---------- quick crop (drag + pinch/scroll zoom) before the ink ---------- */
  var confirmBtn = document.getElementById('confirmCrop');
  var cropUI = document.getElementById('cropUI');
  var adjust = null;   // {ox, oy, z} while the user is framing their photo

  function drawAdjust() {
    var s = lastSource;
    var scale = Math.max(W / s.sw, H / s.sh) * adjust.z;
    var dw = s.sw * scale, dh = s.sh * scale;
    octx.globalCompositeOperation = 'source-over';
    octx.globalAlpha = 1;
    octx.fillStyle = PAPER;
    octx.fillRect(0, 0, W, H);
    octx.drawImage(s.s, (W - dw) * adjust.ox, (H - dh) * adjust.oy, dw, dh);
    octx.strokeStyle = 'rgba(255,255,255,0.4)';
    octx.lineWidth = Math.max(1, W / 600);
    octx.beginPath();
    for (var g = 1; g <= 2; g++) {
      octx.moveTo(W * g / 3, 0); octx.lineTo(W * g / 3, H);
      octx.moveTo(0, H * g / 3); octx.lineTo(W, H * g / 3);
    }
    octx.stroke();
  }

  function enterAdjust() {
    ++animId;
    adjust = { ox: 0.5, oy: 0.5, z: 1 };
    hint.classList.add('gone');
    result.classList.remove('on');
    overlay.classList.remove('gone');
    loupe.style.display = 'none';
    replayBtn.hidden = true;
    loupeHint.hidden = true;
    expandBtn.hidden = true;
    addBtn.hidden = true;
    frameToggle.hidden = true;
    photoMode = false;
    infoBtn.hidden = true;
    infoPop.hidden = true;
    cropUI.hidden = false;
    drawAdjust();
    setStatus('Frame your photo, then see it in e-ink.');
    stageEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  var dragState = null;
  var pointers = {};
  var pinchStart = null;
  panel.addEventListener('pointerdown', function (e) {
    if (adjust) {
      e.preventDefault();
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      panel.setPointerCapture(e.pointerId);
      var ids = Object.keys(pointers);
      if (ids.length === 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        pinchStart = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, z: adjust.z };
        dragState = null;
      } else {
        dragState = { x: e.clientX, y: e.clientY, ox: adjust.ox, oy: adjust.oy };
      }
      return;
    }
    if (rendered) e.preventDefault();
  });
  panel.addEventListener('pointermove', function (e) {
    if (!adjust) return;
    if (pointers[e.pointerId]) { pointers[e.pointerId].x = e.clientX; pointers[e.pointerId].y = e.clientY; }
    var ids = Object.keys(pointers);
    if (ids.length >= 2 && pinchStart) {
      var a = pointers[ids[0]], b = pointers[ids[1]];
      var d = Math.hypot(a.x - b.x, a.y - b.y);
      adjust.z = Math.min(3, Math.max(1, pinchStart.z * (d / pinchStart.d)));
      drawAdjust();
      return;
    }
    if (!dragState) return;
    var rect = panel.getBoundingClientRect();
    var scale = Math.max(W / lastSource.sw, H / lastSource.sh) * adjust.z;
    var overX = lastSource.sw * scale - W, overY = lastSource.sh * scale - H;
    var toDev = W / rect.width;
    if (overX > 1) adjust.ox = Math.min(1, Math.max(0, dragState.ox - (e.clientX - dragState.x) * toDev / overX));
    if (overY > 1) adjust.oy = Math.min(1, Math.max(0, dragState.oy - (e.clientY - dragState.y) * toDev / overY));
    drawAdjust();
  });
  function endDrag(e) {
    delete pointers[e.pointerId];
    if (Object.keys(pointers).length < 2) pinchStart = null;
    dragState = null;
  }
  panel.addEventListener('pointerup', endDrag);
  panel.addEventListener('pointercancel', endDrag);
  panel.addEventListener('wheel', function (e) {
    if (!adjust) return;
    e.preventDefault();
    adjust.z = Math.min(3, Math.max(1, adjust.z * (1 - e.deltaY * 0.002)));
    drawAdjust();
  }, { passive: false });
  panel.addEventListener('contextmenu', function (e) { e.preventDefault(); });

  confirmBtn.addEventListener('click', function () {
    if (!adjust) return;
    lastSource.ox = adjust.ox;
    lastSource.oy = adjust.oy;
    lastSource.z = adjust.z;
    adjust = null;
    cropUI.hidden = true;
    window.__wallieInkConfirmed = Date.now();
    track('ink_preview_adjust_confirmed', {
      ms_since_pick: window.__wallieInkPicked ? Date.now() - window.__wallieInkPicked : null });
    runPipeline(false);
  });

  window.__wallie = {
    refit: refit,
    // The wall view hides .wallie-hero-cta (it would sit on top of the frames
    // and the action row), which left gallery builders with no entry to the
    // preview except the row down by Add to Cart. They still found it seven
    // times more often than single-frame shoppers — so the demand was there
    // and only the door was missing. The wall's own action row opens it now.
    // openModal lives in the SECOND closure of this file (the modal section,
    // line ~814); this object is built in the first. The direct call shipped
    // as a ReferenceError that only fired on tap — every syntax check passed,
    // the button just silently did nothing (owner, 2026-08-26). The bridge is
    // read lazily so closure load order cannot matter.
    openPreview: function () { if (window.__wallieOpenInk) window.__wallieOpenInk(); },
    isRendered: function () { return rendered; },
    ink: function () { return ditherCanvas; },
    setFinish: function (name) { if (FRAMES[name]) { currentFinish = name; applyFinish(); refit(); } },
    exportPhoto: function () {
      try { return (lastSource && lastSource.orig) ? lastSource.orig.toDataURL('image/jpeg', 0.85) : null; } catch (e) { return null; }
    },
    exportInk: function () {
      // only a full-res real-pipeline render may enter the session cache
      if (!usedRealPipeline || !ditherCanvas ||
          Math.max(ditherCanvas.width, ditherCanvas.height) < 1600) return null;
      try { return rendered ? ditherCanvas.toDataURL('image/png') : null; } catch (e) { return null; }
    },
    restoreInk: function (url, cb, photoUrl) {
      if (photoUrl) {
        var pim = new Image();
        pim.onload = function () {
          var pc = document.createElement('canvas');
          pc.width = pim.width; pc.height = pim.height;
          pc.getContext('2d').drawImage(pim, 0, 0);
          // partial source: enough for the Photo/Ink toggle, not for re-rendering
          lastSource = { orig: pc };
        };
        pim.src = photoUrl;
      }
      var im = new Image();
      im.onload = function () {
        // refuse a cached ink below panel res (poisoned by an old fallback)
        if (Math.max(im.width, im.height) < 1600) {
          try {
            sessionStorage.removeItem('walliePreviewInk');
            localStorage.removeItem('walliePreviewInk');
            localStorage.removeItem('walliePreviewPhoto');
            localStorage.removeItem('walliePreviewTs');
          } catch (e) {}
          return;
        }
        ditherCanvas = document.createElement('canvas');
        ditherCanvas.width = im.width; ditherCanvas.height = im.height;
        ditherCanvas.getContext('2d').drawImage(im, 0, 0);
        usedRealPipeline = true;
        rendered = true;
        loupeUrl = url;
        loupe.style.backgroundImage = 'url(' + url + ')';
        hint.classList.add('gone');
        replayBtn.hidden = false; expandBtn.hidden = false; addBtn.hidden = false;
        frameToggle.hidden = false; infoBtn.hidden = false;
        refit();
        if (cb) cb();
      };
      im.src = url;
    }
  };
})();

/* ---------------- PDP glue ---------------- */
(function () {
  'use strict';
  var CFG = window.WALLIE_PREVIEW;
  var modal = document.getElementById('tryModal');
  if (!modal || !window.wallieProcess) return;
  var finishState = 'walnut';
  var styleState = 'round';
  function comboKey() {
    // On the 10″ page prefer that size's own frame shots (keys end in -10);
    // fall back to the 13″ set so a missing 10″ combo degrades, not breaks.
    var k = styleState + '-' + finishState;
    if (!CFG.frames[k] && !CFG.frames[k + '-10']) {
      k = (finishState === 'black' || finishState === 'white')
        ? 'square-' + finishState : 'round-' + finishState;
    }
    return (CFG.ten && CFG.frames[k + '-10']) ? k + '-10' : k;
  }

  // Restored 2026-08-25. These events existed on 15–16 Aug and then vanished in
  // the rework that moved the e-ink door to a corner — leaving nine days with
  // no idea whether anyone opened the preview at all. Without them, any change
  // here (including the wall-row entry) is unmeasurable.
  function track(n, p) { try { if (window.WallieCollect) window.WallieCollect(n, p || {}); } catch (_) {} }
  var openedTs = 0;

  // The wall view's "See it in e-ink" entry reaches this closure through the
  // bridge — see openPreview in the closure above.
  window.__wallieOpenInk = function () { openModal(); };
  function openModal() {
    openedTs = Date.now();
    track('ink_preview_open', { from: modal.dataset.wallieFrom || 'pdp' });
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    if (window.__wallie) {
      window.__wallie.setFinish(finishState);
      setTimeout(window.__wallie.refit, 80);
      setTimeout(window.__wallie.refit, 450);
      setTimeout(window.__wallie.refit, 1100);
    }
  }
  function closeModal() {
    // `rendered` lives in the other closure — read it through the __wallie
    // bridge. The bare name threw on every ✕ click: the modal never closed and
    // the gallery composites two lines down never ran.
    track('ink_preview_close', { ms_open: openedTs ? Date.now() - openedTs : null,
      rendered: !!(window.__wallie && window.__wallie.isRendered && window.__wallie.isRendered()) });
    modal.hidden = true;
    document.body.style.overflow = '';
    ensureSlideComposites();
    prewarmComposites();
    try {
      var inkData = window.__wallie && window.__wallie.exportInk();
      try {
        if (inkData) {
          localStorage.setItem('walliePreviewInk', inkData);
          localStorage.setItem('walliePreviewTs', String(Date.now()));
        }
        var photoData = window.__wallie && window.__wallie.exportPhoto();
        if (photoData) localStorage.setItem('walliePreviewPhoto', photoData);
      } catch (e) {}
    } catch (e) {}
  }
  document.getElementById('modalClose').addEventListener('click', closeModal);
  // The pill opens this modal, so it has no job while the modal is up.
  new MutationObserver(function () {
    document.body.classList.toggle('wallie-modal-open', !modal.hidden);
  }).observe(modal, { attributes: true, attributeFilter: ['hidden'] });
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });

  // prompts are injected DOM — Horizon morphs the product section on
  // variant changes and wipes them, so injection must be self-healing
  function pillHost(media) {
    // Prefer the media-gallery element the wall takeover also mounts on: it is
    // already position:relative (.wallie-media-host), it survives the variant
    // morph better than the inner container, and sharing one coordinate space
    // with "Back to your wall" is what makes the bottom-of-media rule reliable
    // instead of two absolutely-positioned chips guessing at each other.
    var host = document.querySelector('media-gallery');
    if (host) { host.classList.add('wallie-media-host'); return host; }
    return media.closest('li') || media.parentElement || media;
  }
  function ensurePrompts() {
    var heroEl = currentHeroImg();
    var media = heroEl ? heroEl.closest('.product-media-container') : document.querySelector('.product-media-container');
    var existingPill = document.querySelector('.wallie-hero-cta');
    if (media && existingPill) {
      var wantHost = pillHost(media);
      if (existingPill.parentElement !== wantHost) { wantHost.style.position = 'relative'; wantHost.appendChild(existingPill); }
    }
    if (media && !existingPill) {
      // mount OUTSIDE the theme's zoom button — its capture-phase tap
      // handler runs before anything inside it can cancel
      var host = pillHost(media);
      host.style.position = 'relative';
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'wallie-hero-cta';
      // Short, because it now sits in a corner rather than across the bottom.
      pill.innerHTML = '&#65291;&nbsp; Your photo in e-ink';
      // open on pointerup/touchend directly: preventDefault on touchend kills
      // the synthetic click on iOS, so never depend on click alone
      var openedAt = 0;
      function pillOpen(e) {
        e.preventDefault();
        e.stopPropagation();
        var now = Date.now();
        if (now - openedAt > 500) { openedAt = now; openModal(); }
      }
      pill.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
      pill.addEventListener('touchstart', function (e) { e.stopPropagation(); });
      pill.addEventListener('pointerup', pillOpen);
      pill.addEventListener('touchend', pillOpen);
      pill.addEventListener('click', pillOpen);
      host.appendChild(pill);
    }
    if (!document.querySelector('.wallie-preview-row')) {
      var atc = document.querySelector('add-to-cart-component, .add-to-cart, product-form-component button[type="submit"], form[action*="/cart/add"] button[type="submit"]');
      if (atc) {
        var host = atc.closest('product-form-component, form') || atc.parentElement;
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'wallie-preview-row';
        row.innerHTML = '<span style="display:flex;align-items:center;gap:9px"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-3px"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15.5l-4.5-4.5L5 22"/></svg> See your photo in e-ink</span><span>&rarr;</span>';
        row.addEventListener('click', function (e) { e.preventDefault(); openModal(); });
        host.parentElement.insertBefore(row, host);
      }
    }
  }
  var lastInkRef = null;

  function ensureAll() {
    ensurePrompts();
    if (window.matchMedia('(max-width: 749px)').matches) {
      var fs0 = document.querySelector('variant-picker form > fieldset');
      if (fs0) fs0.style.setProperty('margin-top', '4px', 'important');
    }
    var w = window.__wallie;
    if (w && w.isRendered()) {
      // a NEW photo/render replaces the ink canvas — flush every stale
      // composite so the old photo can never linger in the gallery
      var inkNow = w.ink();
      if (inkNow !== lastInkRef) {
        var isFirst = lastInkRef === null;
        lastInkRef = inkNow;
        invalidateComposites();
        var els = document.querySelectorAll('[data-wallie-composite]');
        Array.prototype.forEach.call(els, function (el) { delete el.dataset.wallieComposite; });
        prewarmComposites();
        // keep the session cache current with the LATEST render — never a stale one
        if (!isFirst) {
          try {
            var fresh = w.exportInk();
            if (fresh) {
              localStorage.setItem('walliePreviewInk', fresh);
              localStorage.setItem('walliePreviewTs', String(Date.now()));
            }
            try {
              var freshPhoto = w.exportPhoto();
              if (freshPhoto) localStorage.setItem('walliePreviewPhoto', freshPhoto);
            } catch (e) {}
          } catch (e) {}
        }
      }
      ensureSlideComposites();
      ensureZoomComposites();
    }
  }
  ensureAll();
  setInterval(ensureAll, 1200);

  // finish sync from the theme's variant picker
  function detectFinish() {
    var els = document.querySelectorAll('input[type="radio"]:checked, select');
    var text = '';
    Array.prototype.forEach.call(els, function (el) { text += ' ' + (el.value || ''); });
    text = text.toLowerCase();
    var f = text.indexOf('oak') >= 0 ? 'oak' : text.indexOf('black') >= 0 ? 'black'
          : text.indexOf('white') >= 0 && text.indexOf('oak') < 0 ? 'white' : 'walnut';
    var s = text.indexOf('square') >= 0 ? 'square' : 'round';
    if (f !== finishState || s !== styleState) {
      finishState = f;
      styleState = s;
      if (window.__wallie) window.__wallie.setFinish(comboKey());
    }
  }
  document.addEventListener('change', function () { setTimeout(detectFinish, 50); }, true);
  detectFinish();

  // restore a cached render across reloads / variant navigations
  try {
    var savedInk = null, savedPhoto = null;
    var CACHE_TTL = 7 * 24 * 3600 * 1000;
    try {
      var cacheTs = parseInt(localStorage.getItem('walliePreviewTs') || '0', 10);
      if (localStorage.getItem('walliePreviewInk') && Date.now() - cacheTs > CACHE_TTL) {
        localStorage.removeItem('walliePreviewInk');
        localStorage.removeItem('walliePreviewPhoto');
        localStorage.removeItem('walliePreviewTs');
      }
      savedInk = localStorage.getItem('walliePreviewInk');
      savedPhoto = localStorage.getItem('walliePreviewPhoto');
      if (!savedInk) {
        // migrate anything saved by the sessionStorage era
        savedInk = sessionStorage.getItem('walliePreviewInk');
        savedPhoto = sessionStorage.getItem('walliePreviewPhoto');
      }
    } catch (e) {}
    if (savedInk && window.__wallie) window.__wallie.restoreInk(savedInk, function () { ensureSlideComposites(); prewarmComposites(); }, savedPhoto);
  } catch (e) {}

  // gallery composite — pre-built per combo and applied synchronously so
  // variant switches never flash the stock artwork
  function currentHeroImg() {
    var best = null, bestArea = 0;
    var imgs = document.querySelectorAll('.product-media-container img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].closest('dialog')) continue;   // never the zoom dialog's copies
      var r = imgs[i].getBoundingClientRect();
      var vw = Math.min(r.right, window.innerWidth) - Math.max(r.left, 0);
      var vh = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
      if (vw > 0 && vh > 0 && vw * vh > bestArea) { bestArea = vw * vh; best = imgs[i]; }
    }
    return best || document.querySelector('.product-media-container img');
  }
  var compositeCache = {};
  var compositeGen = 0;
  function invalidateComposites() { compositeCache = {}; compositeGen++; }
  function buildComposite(key, cb) {
    if (compositeCache[key]) { if (cb) cb(compositeCache[key]); return; }
    var w = window.__wallie;
    if (!w || !w.isRendered() || !CFG.frames[key]) return;
    var ink = w.ink();
    if (!ink || ink.width < ink.height) return;
    var f = CFG.frames[key].land;
    var gen = compositeGen;
    var fr = new Image();
    fr.crossOrigin = 'anonymous';
    fr.onload = function () {
      if (gen !== compositeGen) return; // ink changed while loading — stale build
      var cw = 1400;
      var c = document.createElement('canvas');
      c.width = cw; c.height = Math.round(cw * f.h / f.w);
      var x = c.getContext('2d');
      x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
      x.drawImage(fr, 0, 0, c.width, c.height);
      var bw = f.box[2] / 100 * c.width;
      var small = ink;
      while (small.width >= bw * 1.9) {
        var t = document.createElement('canvas');
        t.width = Math.round(small.width / 2); t.height = Math.round(small.height / 2);
        var tc = t.getContext('2d');
        tc.imageSmoothingEnabled = true; tc.imageSmoothingQuality = 'high';
        tc.drawImage(small, 0, 0, t.width, t.height);
        small = t;
      }
      x.filter = 'blur(0.25px)';
      x.drawImage(small, f.box[0] / 100 * c.width, f.box[1] / 100 * c.height,
        f.box[2] / 100 * c.width, f.box[3] / 100 * c.height);
      x.filter = 'none';
      compositeCache[key] = c.toDataURL('image/jpeg', 0.9);
      if (cb) cb(compositeCache[key]);
    };
    fr.src = f.src;
  }
  // Each frame-shot slide shows the photo in ITS OWN style+finish — the
  // carousel becomes "browse your photo across the styles". Slides that are
  // not frame shots (lifestyle, video) are never touched.
  function comboFromSrc(src) {
    // -13f are the 13″ frame shots, -10g the 10″'s (a later shot generation,
    // hence the different letter). Only knowing -13f is why the 10″ gallery
    // never showed the render after closing the modal.
    var m = /(round|square)-(walnut|whiteoak|black|white)-(13f|10g)/.exec(src || '');
    if (!m) return null;
    var fin = m[2] === 'whiteoak' ? 'oak' : m[2];
    var k = m[1] + '-' + fin + (m[3] === '10g' ? '-10' : '');
    return CFG.frames[k] ? k : null;
  }
  function compositeSlide(im) {
    var key = im.dataset.wallieCombo || comboFromSrc(im.currentSrc || im.src);
    if (!key) return;
    buildComposite(key, function (url) {
      im.srcset = ''; im.sizes = '';
      im.dataset.wallieComposite = '1';
      im.dataset.wallieCombo = key;
      im.src = url;
    });
  }
  function ensureSlideComposites() {
    var w = window.__wallie;
    if (!w || !w.isRendered()) return;
    var imgs = document.querySelectorAll('.product-media-container img');
    Array.prototype.forEach.call(imgs, function (im) {
      if (im.closest('dialog')) return;
      if (im.dataset.wallieComposite) return;
      compositeSlide(im);
    });
  }
  function prewarmComposites() {
    // Only this page's size — prewarming the other size's six composites
    // would double the canvas work for slides that never render here.
    var keys = Object.keys(CFG.frames).filter(function (k) {
      return /-10$/.test(k) === !!CFG.ten;
    });
    var i = 0;
    (function next() {
      if (i >= keys.length) return;
      buildComposite(keys[i++], function () { setTimeout(next, 120); });
    })();
  }
  function ensureZoomComposites() {
    var w = window.__wallie;
    if (!w || !w.isRendered()) return;
    var imgs = document.querySelectorAll('dialog[open] img');
    Array.prototype.forEach.call(imgs, function (im) {
      if (im.dataset.wallieComposite) return;
      if (im.getBoundingClientRect().width < 300) return;   // skip thumbnail strip
      var zkey = comboFromSrc(im.currentSrc || im.src);
      if (zkey) {
        buildComposite(zkey, function (url) {
          im.srcset = ''; im.sizes = '';
          im.dataset.wallieComposite = '1';
          im.dataset.wallieCombo = zkey;
          im.src = url;
        });
      }
    });
  }
  // swap the instant the theme touches the gallery, before stock art paints
  new MutationObserver(function () {
    var w = window.__wallie;
    if (!w || !w.isRendered()) return;
    ensureSlideComposites();
  }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['src'], childList: true });
})();
